export default "__VITE_ASSET__57cb4500__"